/* eslint-disable no-magic-numbers */
import React, { useMemo } from 'react';
import 'ol/ol.css';
import { useElementDiagramPreview } from '@/components/FunctionalArea/Modal/EditElementModal/utils/useElementDiagramPreview';

type ElementDiagramPreviewProps = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export const ElementDiagramPreview: React.FC<ElementDiagramPreviewProps> = ({
  x,
  y,
  width,
  height,
}) => {
  const center = useMemo(() => ({ x: x + width / 2, y: y + height / 2 }), [x, y, width, height]);
  const { targetRef } = useElementDiagramPreview(center);

  return <div ref={targetRef} className="h-full w-full" data-testid="element-diagram-preview" />;
};
